import { Box, ListItem, styled } from '@mui/material';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { StyledNormalTypography } from '../theme/StyledElements';
import { useNavigate } from 'react-router-dom';
import { UserContext } from '../providers/UserProvider';
import { getStripeId } from '../services/cloudFirestore';

const StyledBasketSidebar = styled(Box)(() => ({
    width: '300px',
    marginLeft: '97px',
    marginTop: '40px'
}));

interface SidebarProps {
    active: number;
}

export function FarmSidebar({ active }: SidebarProps): JSX.Element {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const user = useContext(UserContext);

    const menuItems = [
        {
            id: 0,
            title: t('myFarm'),
            path: '/view-farm'
        },
        {
            id: 1,
            title: t('myCollection'),
            path: `/collection/view`
        },
        {
            id: 2,
            title: t('myAmoSubscription'),
            path: '/subscription'
        },
        {
            id: 3,
            title: t('myClients'),
            path: '/clients'
        }
    ];

    const handleClick = async (path: string): Promise<void> => {
        if (path === '/subscription' && user && user.idProducteur) {
            const url = await getStripeId(user.idProducteur);
            if (url) {
                window.location.href = url;
            }
        } else {
            navigate(path);
        }
    };

    return (
        <StyledBasketSidebar>
            {menuItems.map((item, key) => (
                <ListItem
                    key={key}
                    button
                    sx={{
                        backgroundColor: active === item.id ? '#394A35' : '#FFFFFF',
                        '&:hover': {
                            backgroundColor: active === item.id ? '#394A35' : '#FFFFFF',
                            color: active === item.id ? '#FFFFFF' : '#394A35'
                        },
                        justifyContent: 'space-between',
                        borderRadius: '0px 20px 20px 0px'
                    }}
                    onClick={(): Promise<void> => handleClick(item.path)}>
                    <StyledNormalTypography
                        variant="subtitle2"
                        color={active === item.id ? '#FFFFFF' : '#394A35'}
                        sx={{ marginLeft: '10px' }}>
                        {item.title}
                    </StyledNormalTypography>
                </ListItem>
            ))}
        </StyledBasketSidebar>
    );
}
